import { render } from "./ViDeo.vue?vue&type=template&id=45e03ee5&scoped=true"
import script from "./ViDeo.vue?vue&type=script&lang=js"
export * from "./ViDeo.vue?vue&type=script&lang=js"

import "./ViDeo.vue?vue&type=style&index=0&id=45e03ee5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e03ee5"]])

export default __exports__